import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './Spacer.module.scss';

type TSpacerProps = {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  webOnly?: boolean;
};

const Spacer: React.FC<TSpacerProps> = ({
  width,
  height,
  style,
  webOnly = false,
}) => {
  return (
    <div
      style={{
        display: 'block',
        paddingBottom: height,
        paddingRight: width,
        ...style,
      }}
      {...(webOnly && { className: Styles['web-only'] })}
    />
  );
};

export default Spacer;
